module.exports = __webpack_public_path__ + "static/media/icon-small-right-arrow.9b33f5fa.svg";